import { useEffect, useState } from "react";
import api from "@/lib/api";

// Approved testimonials for one buyer (by ?b= code). Empty list = hide the section.
export function useBuyerTestimonials(code) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!code) {
      setItems([]);
      return undefined;
    }
    let alive = true;
    api.get("/public/testimonials", { params: { b: code } })
      .then((r) => { if (alive) setItems(r.data?.items || []); })
      .catch(() => { if (alive) setItems([]); });
    return () => { alive = false; };
  }, [code]);
  return items;
}
